var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "list_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#list_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.422 17.083q-.63 0-1.068-.437a1.45 1.45 0 0 1-.438-1.07V4.424q0-.631.438-1.069a1.45 1.45 0 0 1 1.068-.437h11.154q.631 0 1.07.437.436.438.437 1.069v11.154q0 .63-.438 1.069a1.46 1.46 0 0 1-1.069.437zm0-1.25h11.154a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176V4.423a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H4.422a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v11.154q0 .096.08.176t.176.08m2.244-1.875h4.167q.265 0 .445-.18.18-.179.18-.445a.6.6 0 0 0-.18-.445.6.6 0 0 0-.445-.18H6.666a.6.6 0 0 0-.445.18.6.6 0 0 0-.18.445q0 .267.18.446.18.18.445.18m0-3.333h6.667q.265 0 .445-.18t.18-.445a.6.6 0 0 0-.18-.446.6.6 0 0 0-.445-.18H6.666a.6.6 0 0 0-.445.18.6.6 0 0 0-.18.446q0 .266.18.445.18.18.445.18m0-3.333h6.667q.265 0 .445-.18t.18-.445a.6.6 0 0 0-.18-.446.6.6 0 0 0-.445-.18H6.666a.6.6 0 0 0-.445.18.6.6 0 0 0-.18.446q0 .265.18.445t.445.18"
  }))));
};
export default SvgList;